import { parseISO } from "date-fns";

function isIsoDateString(value: unknown): boolean {
    if (typeof value !== "string") {
        return false;
    }
    const isoDateFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;

    return isoDateFormatRegex.test(value);
}

export function handleDates<T = unknown>(body: T): T {
    if (body === null || body === undefined || typeof body !== "object") {
        return body;
    }
    return Object.entries(body).reduce((acc, [key, value]) => {
        if (isIsoDateString(value)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            acc[key] = parseISO(value);
        } else if (typeof value === "object") {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            acc[key] = handleDates(value);
        }
        return acc;
    }, body);
}
